module.exports = __webpack_public_path__ + "static/media/option-3.94bb7ee9.ogg";